import Link from 'next/link';
import React, { useEffect, useState } from 'react';
import Form from 'react-bootstrap/Form';
import { usePaymentContext } from '../../context/Payment';
// import styles from './styles'
import axios from 'axios';
import { DateTime } from 'luxon';
import { RichText } from 'prismic-reactjs';
import { Button, Col, Modal, Row } from 'react-bootstrap';
import Section from '../../components/Section';
import { useFranchiseeContext } from '../../context/Franchisee';
import { SET_APPOINTMENT, SET_TIP, useLeadContext } from '../../context/Lead';
import TermsAndConditions from '../../pages/terms-and-conditions';
import htmlSerializer from '../../SDKs/Prismic/htmlSerializer';
import { PrismicClient } from '../../SDKs/Prismic/prismic.config';
import * as Sentry from '@sentry/node';

interface BookingTermsAndConditionsProps {
  autoLeadTipApplied?: any;
}
const BookingTermsAndConditions: React.FC<BookingTermsAndConditionsProps> = ({
  autoLeadTipApplied,
}: BookingTermsAndConditionsProps) => {
  const { paymentState, sendToPaymentState } = usePaymentContext();
  const { lead, dispatchLead } = useLeadContext();
  const { franchisee } = useFranchiseeContext();
  const [disabled, setDisabled] = useState<boolean>(true);
  const [tacData, setTacData] = useState<any>();
  const [showModal, setShowModal] = useState<boolean>(false);
  const [agreed, setAgreed] = useState<boolean>(false);

  const toggleChecked = (event) => {
    let accepted: boolean;
    if (event.target.checked === true || event.target.innerText === 'I agree') {
      accepted = true;
      setAgreed(true);
      if (autoLeadTipApplied) {
        const leadTotalPrice =
          Number(lead.price) + Number(lead.tax) + Number(lead.serviceFee);
        const tipPercent = Number((Number(leadTotalPrice) * 0.15).toFixed(2));

        axios
          .post('/api/set-lead-tip/', {
            tip: tipPercent,
            service_fee: lead.serviceFee,
            id: lead.id,
          })
          .then((res) => {
            dispatchLead({
              type: SET_TIP,
              payload: {
                tip: tipPercent,
                totalPrice: res.data.total_price,
              },
            });
          })
          .catch((err) => {
            console.log(err);
            Sentry.captureException(err);
          });

        axios
          .post('/api/tips-session/', {
            tipsData: {
              tips: tipPercent,
            },
          })
          .then((res) =>{})
          .catch((e) => {
            console.log(e);
            Sentry.captureException(e);
          });
      }
    } else {
      accepted = false;
      setAgreed(false);
    }
    // const checkBox: HTMLInputElement = event.target;
    // const accepted: boolean = checkBox.checked;

    if (accepted) {
      sendToPaymentState('ACCEPTED');
      sendToPaymentState('READY');
    } else {
      sendToPaymentState('REFUSED');
    }
  };

  useEffect(() => {
    switch (true) {
      case paymentState.matches('idle') && lead.zipCode !== '':
      case paymentState.matches('ready'):
      case paymentState.matches('refused'):
        setDisabled(false);
        break;
      default:
        setDisabled(true);
        break;
    }
  }, [paymentState, lead.zipCode]);

  useEffect(() => {
    async function fetchTAC() {
      try {
        const termsAndConditions = await PrismicClient().getSingle(
          'terms-and-conditions',
          {}
        );
        setTacData(termsAndConditions);
      } catch (e) {
        console.log(e);
      }
    }
    fetchTAC();
  }, []);

  return (
    <>
      <div className='form-section-header mb-2'>
          Agreement
      </div>
      <div className='d-flex justify-content-start mt-1 mb-2'>
        {/* Add booking terms and conditions Content Here */}
        <Form.Check
          aria-label='agree to the terms and conditions'
          disabled={disabled}
          onClick={toggleChecked}
          className='pr-3 confirm-checkbox'
          checked={agreed}
        />
        <p className='booking-info-text'>
          Check here to indicate the you have read and agree to the{' '}
          <a
            onClick={() => {
              setShowModal(true);
            }}
            style={{
              color: '#D4357F',
              textDecoration: 'underline',
              cursor: 'pointer',
            }}
          >
            Two Maids Terms and Conditions
          </a>
          .
        </p>
        {/* <RichText render={tacData} htmlSerializer={htmlSerializer} /> */}

        <Modal
          show={showModal}
          onHide={() => {
            setShowModal(false);
          }}
          aria-labelledby='contained-modal-title-vcenter'
          centered
          style={{ padding: '10px' }}
          scrollable={true}
          className='tac-modal'
        >
          <Modal.Header className='d-flex justify-content-between align-items-center'>
            <Modal.Title style={{ margin: 'auto' }}>
              Terms and Conditions
            </Modal.Title>
          </Modal.Header>
          <Modal.Body className='px-0'>
            <Section xs={11} lg={11}>
              <Row className='justify-content-center'>
                <Col xs={12} lg={12} xl={12}>
                  <div className='mb-3'>
                    <span className='text-uppercase font-weight-bold'>
                      Last Updated{' '}
                      {DateTime.fromISO(
                        tacData?.last_publication_date
                      ).toLocaleString(DateTime.DATE_FULL)}
                    </span>
                  </div>
                  <RichText
                    render={tacData?.data?.content}
                    htmlSerializer={htmlSerializer}
                  />
                  <span className='text-uppercase font-weight-bold'>
                    Last Updated{' '}
                    {DateTime.fromISO(
                      tacData?.last_publication_date
                    ).toLocaleString(DateTime.DATE_FULL)}
                  </span>
                </Col>
              </Row>
            </Section>
          </Modal.Body>
          <Modal.Footer>
            <Button variant='secondary' onClick={() => setShowModal(false)}>
              Close
            </Button>
            <Button
              variant='primary'
              onClick={(e) => {
                toggleChecked(e);
                setShowModal(false);
              }}
            >
              I agree
            </Button>
          </Modal.Footer>
        </Modal>
      </div>
      <span className='tip-bottom-text'>
      By submitting this form, you consent to receive calls, SMS (text) notifications, and email messages at the contact information provided, related to delivering our services. You may text STOP at any time to opt out of the SMS (text) messages. 
      Message &amp; data rates may apply. Please review our <a href='/privacy-policy' target='_blank'>Privacy Policy</a>.
      </span>
    </>
  );
};

BookingTermsAndConditions.defaultProps = {
  // add booking terms and conditions default props here
  // className: null,
};

export default BookingTermsAndConditions;
